import { useTranslations } from "next-intl";
import { RetailCartItem } from "@/dto/retailCartItem";
import { getFromLocalStorage } from "@/utils/localStorageUtils";
import { LocalStorageKey } from "@/utils/storageKeys";

export const DeliveryEstimateBanner = ({ merchant, onAddMore }: any) => {
  const t = useTranslations("DeliveryEstimateBanner");
  const cartItems = getFromLocalStorage<RetailCartItem[]>(
    LocalStorageKey.CART,
    []
  );
  const totalPrice =
    cartItems.reduce((total: number, i: any) => (total += i.value.total), 0) /
    100;
  const deliveryFee = merchant.deliveryFee;
  const hasMetMinimumFreeDeliveryPrice =
    merchant.deliveryOrderNoFeesAmount / 100 <= totalPrice;
  const hasMetMinimumDelivery = merchant.deliveryMinimum / 100 <= totalPrice;
  return (
    <>
      <div
        className={`rounded-lg ${
          hasMetMinimumDelivery
            ? "bg-[#eefbfc] border-[#69D0DD]"
            : "bg-[#FFF6CC] border-[#FFD100]"
        }
        ${deliveryFee > 0 || !hasMetMinimumDelivery ? "p-4" : ""}`}
      >
        {hasMetMinimumFreeDeliveryPrice && deliveryFee > 0 && (
          <p className="font-semibold text-[18px]">
            {t("freeDelivery")}
          </p>
        )}
        {deliveryFee !== undefined &&
          deliveryFee > 0 &&
          hasMetMinimumDelivery &&
          !hasMetMinimumFreeDeliveryPrice && (
            <>
              <p className="font-semibold text-[18px]">
                {t("awayFromFreeDelivery", { amount: (merchant.deliveryOrderNoFeesAmount / 100 - totalPrice).toFixed(2) })}
              </p>
              <p>
                <span
                  onClick={() => onAddMore && onAddMore()}
                  className="underline cursor-pointer"
                >
                  {t("addMoreToCart")}
                </span>{" "}
                {t("removeDeliveryFees")}
              </p>
            </>
          )}
        {!hasMetMinimumDelivery && (
          <>
            <p className="font-semibold text-[18px]">
              {t("minimumForDelivery", { amount: (merchant.deliveryMinimum / 100).toFixed(2) })}
            </p>
            <p>
              <span
                onClick={() => onAddMore && onAddMore()}
                className="underline cursor-pointer"
              >
                {t("addMoreToCart")}
              </span>{" "}
              {t("placeYourOrder")}
            </p>
          </>
        )}
      </div>
    </>
  );
};
